/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Restore_ButtonInputs */



/**
* | output |
* | --- |
* | "Restore" |
*
* @param {Snapshot_History_Restore_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_restore_button = /** @type {((inputs?: Snapshot_History_Restore_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Restore_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restore")
	if (locale === "de") return /** @type {LocalizedString} */ ("Restore")
	if (locale === "it") return /** @type {LocalizedString} */ ("Restore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Restore")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restore")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Restore")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Restore")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Restore")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restore")
	return /** @type {LocalizedString} */ ("Restore")
});